module.exports = __webpack_public_path__ + "02_mid_grey.6a63e3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_mid_grey.png
// module id = 47qr
// module chunks = 0